import { Navigate, useRoutes } from "react-router-dom";
// layouts
import DashboardLayout from "./layouts/dashboard";
// import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
//
import Login from "./pages/Login";
// import SignIn from "./pages/SignIn";
// import Register from "./pages/Register";
import DashboardApp from "./pages/DashboardApp";
// import Authentication from "./pages/Authentication";
import Reports from "./pages/Reports";
// import UserInfo from "./pages/UserInfo";
import Locations from "./pages/Locations";
import FarmAnalyze from "./pages/FarmAnalyze";
import NotFound from "./pages/Page404";
import ProductType from "./pages/ProductType";
import Requests from "./pages/Requests";
import Steps from "./pages/Steps";
import StepItems from "./pages/StepItems";
import Products from "./pages/Products";
import ProductStep from "./pages/ProductStep";
import Models from "./pages/Models";
import ModelItems from "./pages/ModelItems";
import Additional from "./pages/Additional";
import AdditionalItems from "./pages/AdditionalItems";
import DetailItemDimension from "./pages/DetailItemDimension";
import Details from "./pages/Details";
import DetailItems from "./pages/DetailItems";
import ReceivedOrders from "./pages/ReceivedOrders";
import OrderDetails from "./pages/OrderDetails";
import Members from "./pages/Members";
import Users from "./pages/Users";
import Setting from "./pages/Setting";
import SetPassword from "./pages/SetPassword";
import DiscountCodes from "./pages/DiscountCodes";
import { Routes, Route } from "react-router-dom";
// import history from "./history";
// ----------------------------------------------------------------------

export default function Router() {
  return (
    <Routes>
      <Route path="/" element={<DashboardLayout />}>
        <Route path="/" element={<Navigate to="/steps" replace />} />
        <Route path="/dashboard" element={<DashboardApp />} />

        <Route path="/steps">
          <Route index element={<Steps />} />
          <Route path="*" element={<StepItems />} />
        </Route>
        <Route path="/products">
          <Route index element={<Products />} />
          <Route path="*" element={<ProductStep />} />
        </Route>
        <Route path="/models">
          <Route index element={<Models />} />
          <Route path="*" element={<ModelItems />} />
        </Route>
        <Route path="/additional">
          <Route index element={<Additional />} />
          <Route path="*" element={<AdditionalItems />} />
        </Route>
        <Route path="/details">
          <Route index element={<Details />} />
          <Route path=":detailId" element={<DetailItems />} />
          <Route
            path=":detailId/:detailItemId"
            element={<DetailItemDimension />}
          />
        </Route>
        <Route path="/receivedorders">
          <Route index element={<ReceivedOrders />} />
        </Route>
        <Route path="/members">
          <Route index element={<Members />} />
        </Route>
        <Route path="/discount-codes">
          <Route index element={<DiscountCodes />} />
        </Route>
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/password" element={<SetPassword />} />
      <Route path="/receivedorders/:orderId" element={<OrderDetails />} />
      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
